export default __webpack_public_path__ + "static/media/logo.c59d4c76.png";